import * as React from 'react';
import { DataType } from './tableModels';
// tslint:disable-next-line:no-var-requires
const shortid = require('shortid');

interface Props {
    object: RowObject;
    cssClassName?: string;
}

// tslint:disable-next-line:no-empty-interface
interface State {
    //
}

interface RowObject {
    type: DataType;
    obj: string | number | boolean | JSX.Element;
    // tslint:disable-next-line
    f?: any;
    id?: number;
    cssClassName?: string;
}
class TableBodyRowObject extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            cssClassName: ''
        };
        this.renderBodyRowObject = this.renderBodyRowObject.bind(this);
    }

    renderBodyRowObject(props: Props) {
        if (props.object.type === DataType.element || DataType.string || DataType.number || DataType.boolean) {
            return (
                <div
                    key={shortid.generate()}
                    onClick={(e) => {
                        if (this.props.object.f) {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.object.f();
                        }
                    }}
                >
                    {props.object.obj}
                </div>
            );
        } else {
            return <div key={shortid.generate()} />;
        }
    }
    /*tslint:disable */
    public render() {
        return <td className={this.props.cssClassName}>{this.renderBodyRowObject(this.props)}</td>;
    }
}

export default TableBodyRowObject;



// WEBPACK FOOTER //
// ./src/components/table/tableBodyRowObject.tsx